// src/features/invoice/pages/InvoicePage.jsx
import React from "react";
import InvoiceManager from "../components/InvoiceManager";
import ErrorBoundary from "../../../components/common/ErrorBoundary";

const InvoicePage = () => {
  return (
    <ErrorBoundary>
      <InvoiceManager />
    </ErrorBoundary>
  );
};

export default InvoicePage;
